"use client"

import { useSports } from "hooks"

import { LeagueSkeleton } from "compositions/events/League/League"
import EmptyContent from "compositions/events/EmptyContent/EmptyContent"
import Navbar, { NavbarSkeleton } from "compositions/events/Navbar/Navbar"
import { useParams } from "next/navigation"
import OvertimeUniqueEvents from "@/compositions/events/UniqueEvents/OvertimeUniqueEvents"
import OvertimeFilteredLeagues from "@/compositions/events/FilteredLeagues/OvertimeFilteredLeagues"
import OverTimeSport from "@/compositions/events/Sport/OverTimeSport"

export default function OvertimeLeaguePage() {
  const params = useParams()

  const { sports, loading } = useSports()

  if (loading) {
    return (
      <>
        <NavbarSkeleton />
        <LeagueSkeleton isPage />
      </>
    )
  }

  const sport = sports?.find(s => s.slug === params?.sportSlug)
  const league = sport?.leagues?.find(l => l.slug === params?.leagueSlug)

  if (!sport || !league) {
    return <EmptyContent />
  }

  const { slug } = sport

  return (
    <Navbar>
      <OverTimeSport sport={sport} isPage showFilter league={league}>
        {sport.slug === "unique" ? (
          <OvertimeUniqueEvents leagues={[league]} isFirstSport />
        ) : (
          <OvertimeFilteredLeagues
            sportSlug={slug}
            leagues={[league]}
            isFirstSport
          />
        )}
      </OverTimeSport>
    </Navbar>
  )
}
